import React, { useMemo, useState } from "react";
import { useStaticQuery, graphql, navigate } from "gatsby";
import axios from "axios";
import styled, { css } from "styled-components";
import { Confirmation, FormField, FormWrapper } from "./Form";
import { getGAClientId } from '../utils/getGAClientId';
import randomstring from "randomstring"
import { FileInput } from "./FileInput";

const ButtonStyles = styled.button`
  ${({ ...props }) => css`
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15), 0 2px 2px rgba(0, 0, 0, 0.15),
      0 4px 4px rgba(0, 0, 0, 0.15), 0 8px 8px rgba(0, 0, 0, 0.15);
    min-width: 200px;
  `}
`;

const FormFooterStyles = styled.div`
  ${({ ...props }) => css`
    h3 {
      margin-top: 24px;
    }
    a {
      color: ${props.theme.colors.primary};
    }
  `}
`;

export const ContactEnquiryForm = () => {
  const siteData = useStaticQuery(graphql`
    query ContactFormQuery {
      wp {
        siteSettings {
          siteSettings {
            contactFormHeading
            contactFormSubheading
          }
        }
      }
      site {
        siteMetadata {
          contactFormEndpoint
        }
      }
    }
  `);

  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  });
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  
  const handleServerResponse = (ok, msg, form) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    });
    if (ok) {
      setFiles([]);
      setFileError("");
      form.reset();
    }
  };
  const handleOnSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    setServerState({ submitting: true });

    const formData = new FormData(form);
    files.forEach(file => formData.append("file", file));

    axios({
      method: "post",
      url: siteData.site.siteMetadata.contactFormEndpoint,
      data: formData,
    })
      .then((r) => {
        const email = form.email.value;
        const phone = form.tel.value;
        handleServerResponse(true, "Thank you for your enquiry", form);
        dataLayer.push({
          event: 'formSubmit',
          formName: 'careerApplicationForm',
          userEmail: email,
          userPhone: phone
        })
        navigate(`/ssf-confirmation-page`);
      })
      .catch((r) => {
        console.error(r)
        handleServerResponse(false, r?.response?.data?.error ?? r, form);
      });
  };

  const rand = useMemo(() => randomstring.generate(5), []);

  return (
    <FormWrapper>
      <h2>{siteData.wp.siteSettings.siteSettings.contactFormHeading}</h2>
      <p>{siteData.wp.siteSettings.siteSettings.contactFormSubheading}</p>

      <form onSubmit={handleOnSubmit} encType="multipart/form-data">
        <input
          type="hidden"
          name="googleClientId"
          id={`${rand}_googleClientId`}
          value={getGAClientId()}
          hidden
        />
        <FormField>
          <input
            type="text"
            name="name"
            id={`${rand}_name`}
            aria-describedby="name"
            placeholder="Name"
            required
          />
          <label htmlFor={`${rand}_name`}>Name</label>
        </FormField>
        <FormField>
          <input
            type="email"
            name="email"
            id={`${rand}_email`}
            aria-describedby="email"
            placeholder="Email"
            required
          />
          <label htmlFor={`${rand}_email`}>Email</label>
        </FormField>
        <FormField>
          <input
            type="tel"
            name="tel"
            id={`${rand}_tel`}
            aria-describedby="tel"
            placeholder="Phone number"
            required
          />
          <label htmlFor={`${rand}_tel`}>Phone number</label>
        </FormField>
        <FormField>
          <input
            type="text"
            name="company"
            id={`${rand}_company`}
            aria-describedby="company"
            placeholder="Company (optional)"
          />
          <label htmlFor={`${rand}_company`}>Company (optional)</label>
        </FormField>
        <FormField>
          <label htmlFor={`${rand}_preferredContactMethod`} className="sr-only">
            Preferred contact method
          </label>
          <select name="preferredContactMethod" id={`${rand}_preferredContactMethod`}>
            <option value="unselected"> Preferred contact method</option>
            <option value="email">Email</option>
            <option value="phone">Phone</option>
          </select>
        </FormField>
        <FormField>
          <textarea
            type="text"
            name="enquiry"
            id={`${rand}_enquiry`}
            aria-describedby="enquiry"
            placeholder="Enquiry"
            required
          />
          <label htmlFor={`${rand}_enquiry`}>Enquiry</label>
        </FormField>
        <FileInput
          files={files}
          setFiles={setFiles}
          error={fileError}
          setError={setFileError}
        />
        <FormFooterStyles>
          <div>
            <ButtonStyles type="submit" disabled={serverState.submitting || !!fileError}>
              Send Enquiry
            </ButtonStyles>
            <p className="no-js">Please enable Javascript to continue</p>
            {serverState.status && (
              <Confirmation>
                <p className={!serverState.status.ok ? "errorMsg" : ""}>
                  {serverState.status.msg}
                </p>
              </Confirmation>
            )}
          </div>
        </FormFooterStyles>
      </form>
    </FormWrapper>
  );
};
